<template>
  <div class="page nav-page">
    <header class="page-header">
      <div class="header-content">
        <h1>网址导航</h1>
        <p>FishROS 开源资源与工具导航中心，统一收录学习资料、镜像代理与社区入口。</p>
      </div>
      <div class="search">
        <input
          v-model="keyword"
          type="text"
          placeholder="搜索名称或描述"
        >
      </div>
    </header>

    <div class="content">
      <aside class="sidebar">
        <button
          v-for="category in categories"
          :key="category"
          :class="['tab', { active: activeCategory === category }]"
          @click="activeCategory = category"
        >
          {{ category }}
          <span class="count">{{ countByCategory(category) }}</span>
        </button>
      </aside>

      <section class="cards">
        <div v-if="loading" class="empty">加载中...</div>
        <a
          v-for="link in filteredLinks"
          :key="link.id"
          :href="link.url"
          target="_blank"
          rel="noopener"
          class="link-card"
        >
          <div v-if="typeof link.logo === 'string' && link.logo.length <= 2" class="logo emoji-logo">{{ link.logo }}</div>
          <img
            v-else
            :src="link.logo || defaultLogo"
            :alt="link.name"
            class="logo"
          >
          <div class="info">
            <h3>{{ link.name }}</h3>
            <p>{{ link.desc }}</p>
          </div>
        </a>
        <div v-if="!loading && filteredLinks.length === 0" class="empty">
          暂无匹配资源，请尝试其他分类或关键词。
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import defaultLogo from '@/imgs/logo.png'
import { getNavLinks } from '@/server.js'

export default {
  data () {
    return {
      keyword: '',
      activeCategory: '全部',
      defaultLogo,
      navLinks: [],
      loading: false
    }
  },
  computed: {
    categories () {
      const out = ['全部']
      const seen = new Set()
      const list = (this.navLinks || []).slice().sort((a, b) => {
        const sortA = typeof a.sort === 'number' ? a.sort : 9999
        const sortB = typeof b.sort === 'number' ? b.sort : 9999
        return sortA - sortB || (a.id || 0) - (b.id || 0)
      })
      for (const item of list) {
        const cat = (item && item.catelog) ? String(item.catelog).trim() : ''
        if (!cat || seen.has(cat)) continue
        seen.add(cat)
        out.push(cat)
      }
      return out
    },
    filteredLinks () {
      const keyword = this.keyword.trim().toLowerCase()
      return this.navLinks
        .filter(link => !link.hide)
        .filter(link => {
          const inCategory = this.activeCategory === '全部' || link.catelog === this.activeCategory
          const inKeyword = !keyword ||
            link.name.toLowerCase().includes(keyword) ||
            String(link.desc || '').toLowerCase().includes(keyword) ||
            link.url.toLowerCase().includes(keyword)
          return inCategory && inKeyword
        })
        .slice()
        .sort((a, b) => {
          const sortA = typeof a.sort === 'number' ? a.sort : 9999
          const sortB = typeof b.sort === 'number' ? b.sort : 9999
          return sortA - sortB || a.id - b.id
        })
    }
  },
  created () {
    this.loadNavLinks()
  },
  methods: {
    async loadNavLinks () {
      this.loading = true
      try {
        const res = await getNavLinks()
        this.navLinks = (res && res.data) ? res.data : []
        if (this.activeCategory !== '全部' && !this.categories.includes(this.activeCategory)) {
          this.activeCategory = '全部'
        }
      } catch (e) {
        this.navLinks = []
      } finally {
        this.loading = false
      }
    },
    countByCategory (category) {
      if (category === '全部') {
        return this.navLinks.filter(link => !link.hide).length
      }
      return this.navLinks.filter(link => !link.hide && link.catelog === category).length
    }
  }
}
</script>

<style scoped>
  .page {
  width: 88%;
  max-width: 1280px;
  margin: 0 auto;
  padding-bottom: 60px;
}
.page-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background: #fff;
  padding: 24px 28px;
  border-radius: 12px;
  text-align: center;
}
.header-content {
  width: 100%;
}
.page-header h1 {
  margin: 0 0 8px;
  color: #1f2b5b;
}
.page-header p {
  margin: 0;
  color: #666;
}
.search input {
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  width: min(560px, 92vw);
  min-width: 280px;
}
.content {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 24px;
  margin-top: 24px;
}
.sidebar {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.tab {
  background: #fff;
  border: 1px solid #ececec;
  padding: 10px 14px;
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tab.active {
  border-color: #3d5af1;
  color: #3d5af1;
  font-weight: 600;
}
.count {
  font-size: 12px;
  color: #999;
}
.cards {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
}
.link-card {
  display: flex;
  gap: 12px;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #ececec;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;
  cursor: pointer;
}
.link-card:hover {
  border-color: #3d5af1;
  box-shadow: 0 4px 12px rgba(61, 90, 241, 0.1);
  transform: translateY(-2px);
}
.logo {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: contain;
  background: #f5f7fa;
  border: 1px solid #e8eaed;
  box-sizing: border-box;
  padding: 6px;
  flex-shrink: 0;
}
.emoji-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  padding: 0;
  flex-shrink: 0;
}
.info {
  flex: 1;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.info h3 {
  margin: 0 0 6px;
  color: #1f2b5b;
}
.info p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}
.empty {
  grid-column: 1 / -1;
  background: #fff;
  padding: 24px;
  border-radius: 10px;
  text-align: center;
  color: #888;
}
@media screen and (max-width: 900px) {
  .content {
    grid-template-columns: 1fr;
  }
  .sidebar {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .tab {
    flex: 1 1 140px;
  }
}
@media screen and (max-width: 768px) {
  .page {
    width: 90%;
  }
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
